<template>
  <Fragment>
    <v-menu v-model="show" :close-on-content-click="true" :nudge-width="150" offset-y transition="slide-y-transition" max-width="100">
      <template v-slot:activator="{ on }">
        <v-tooltip v-on="on" top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" x-small right class="mb-2" color="primary" @click="showStackType">
              <v-icon small>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('common.add') }}</span>
        </v-tooltip>
      </template>
      <v-card class="mx-auto">
        <v-list dense>
          <v-list-item @click="addSystem('jco')">
            <v-list-item-title>ABAP Stack</v-list-item-title>
          </v-list-item>
          <v-list-item @click="addSystem('jmx')">
            <v-list-item-title>JAVA Stack</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <component v-bind:is="component" v-model="showForm" />
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import { pascalCase } from 'change-case';

export default {
  components: { Fragment },
  data() {
    return {
      show: false,
      showForm: false,
      component: null,
    };
  },
  methods: {
    showStackType() {
      this.show = true;
    },
    async addSystem(type) {
      const form = pascalCase(type);
      this.component = (await import(`./${form}Form.vue`)).default;
      this.showForm = true;
    },
  },
};
</script>
